import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import ExpandableSection from '../../../../components/ExpandableSection';
import AnalyticsLogger from '../../../../helpers/analytics/analyticsLogger';

import RightArrow from '../../../../assets/images/arrow-button.svg';
import TrashIcon from '../../../../assets/images/trash.svg';
import OfflineCloudIcon from '../../../../assets/images/offline-cloud.svg';

import './TaskInventory.scss';
export class TaskInventory extends React.Component {

  constructor(props) {
    TaskInventory.propTypes =  {
      // an array of objects containing normalized information from both Inventory and InventoryItem 
      items: PropTypes.arrayOf(PropTypes.object).isRequired,
    
      task: PropTypes.object,
    
      mobile: PropTypes.bool,
      // Whether the user has permission to edit the task, and thus the inventory items
      editMode: PropTypes.bool,
    };

    super(props);
    this.state = {
      isExpanded: false,
    };

    const currentRole = props.currentUser ? props.currentUser.role : null;
    this.analyticsLogger = new AnalyticsLogger({
      currentRole,
      isMobile: !!window.cordova,
    });

    this.handleOnExpand = this.handleOnExpand.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.task && this.props.task && prevProps.task.id != this.props.task.id) {
      this.setState({ isExpanded: false }); 
    }
  }

  // Click handlers
  deleteInventoryItem(inventoryItem) {
    this.analyticsLogger.logInventoryEvent('DeleteInventory');
    if (this.props.deleteInventoryItem) {
      this.props.deleteInventoryItem(inventoryItem);
    }
  }
  
  editInventoryItem(inventoryItem) {
    if (this.props.editInventoryItem) {
      this.props.editInventoryItem(inventoryItem);
    }
  }
  
  handleOnExpand(expanded) {
    this.setState({ isExpanded: expanded });  
  }

  render() {
    const { items, editMode, handlePopupInventoryAdd } = this.props;
    const { isExpanded } = this.state;
    if (!items){
      return null;
    }
    // mobile is true by default
    let mobile = this.props.mobile != false;
    
    const itemList = items.map(
      inventoryItem => {
        let offlineChangesIndicator = null;
        if (inventoryItem._dirty) {
          offlineChangesIndicator = <img className="offline-indicator" src={OfflineCloudIcon} alt="changes pending"></img>;
        }
        let taskInventory = 
          <span className="task-inventory__item" key={inventoryItem.id ? inventoryItem.id : Math.random()}  onClick={() => this.editInventoryItem(inventoryItem)} >
            <div className="item-id-name">
              <p className="item-id-name__id">{inventoryItem.identifier}</p>
              <p className="item-id-name__name">{inventoryItem.inventory ? inventoryItem.inventory.name : ''}</p>
            </div>
            {offlineChangesIndicator}
            {
              mobile ?
                <img className="task-inventory__arrow" src={RightArrow} alt="right arrow"/>
                : editMode ?
                  <img className="task-inventory__trash-can" src={TrashIcon} alt="trash can" onClick={() => this.deleteInventoryItem(inventoryItem)} />
                  : null
            }
          </span>;
        return taskInventory;
      });
    return (
      <ExpandableSection name="Inventory Management" initiallyExpanded={isExpanded} onExpand={this.handleOnExpand}>
        <div className={'task-inventory ' + (editMode ? 'task-inventory--edit' : '') }>
          {
            mobile &&
            <button className="task-inventory__add-button" onClick={handlePopupInventoryAdd || null}>ADD INVENTORY ITEM</button>
          }
          {
            (items && items.length) ?
            itemList :
            <p className="task-inventory__no-items">No Inventory found.</p>
          }
        </div>
      </ExpandableSection>
    );
  }

}

export default connect((state) => {
  return {
    currentUser: state.new_users.currentUser,
  };
})(TaskInventory);



// WEBPACK FOOTER //
// ./src/containers/TasksContainer/MobileTaskDetails/TaskInventory/index.js